import React from "react";
import { breakpoints } from "@mytutor/shared-react-web-components/lib/theme";
import { SerializedStyles, css } from "@emotion/react";
import Image from "next/image";

const style = css({
  padding: "4% 8%",
  display: "flex",
  flexDirection: "column",
  maxWidth: "480px",
  height: "fit-content",
  textAlign: "center",
  fontSize: "18px",
  color: "#5b5b5b",
  lineHeight: 1.2,
  backgroundColor: "white",

  [`@media (min-width: ${breakpoints.desktop}px)`]: {
    maxWidth: "340px",
  },

  h2: {
    textAlign: "center",
    margin: "0 0 0.5rem 0",
    fontSize: "26px",
    lineHeight: 1.1,
    fontWeight: 600,
  },

  p: {
    fontSize: "16px",
    color: "#666666",
  },

  strong: {
    fontWeight: 500,
  },

  figure: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
});

type Props = {
  title: string;
  body: string;
  image: {
    src: string;
    alt: string;
    height: number;
    width: number;
  };
  additionalStyles?: SerializedStyles;
  children?: React.ReactElement;
};

export const InfoBox = ({
  title,
  body,
  additionalStyles,
  image,
  children,
}: Props) => {
  return (
    <div className="aside-container aside-cta" css={[style, additionalStyles]}>
      <figure>
        <Image alt={image.alt} {...image} />
      </figure>
      <div>
        <h2>{title}</h2>
        <p>{body}</p>
      </div>
      {children}
    </div>
  );
};
